module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./BindView.js"));
	}, "BindView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BindView!./src/pages/Shop/Member/Personal/Account/Bind/BindView.js
// module id = 1477
// module chunks = 418